module.exports = __webpack_public_path__ + "img/loader.f0d07c08.svg";